import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const MetaLeadgenHome = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/meta-leadgen'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_meta_leadgen',
          component: MetaLeadgenHome,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
